/*
 * Palo Alto Theme - Custom JavaScript
 *
 * Consolidated custom interactions and globally delegated handlers.
 */

(function () {
  'use strict';

  /* =========================================================================
   * Sibling Colour Swatch Interactions & Hover Previews
   * ========================================================================= */
  function initSiblingSwatches() {
    /* Cache for preloaded swatch images to guarantee zero-latency swapping */
    var imageCache = {};

    function preloadImage(src) {
      if (!src || imageCache[src]) return;
      var img = new Image();
      img.decoding = 'async';
      img.src = src;
      imageCache[src] = img;
    }

    function preloadCardSwatches(card, includeHidden) {
      if (!card) return;
      var selector = includeHidden
        ? '.relateditems a[data-image]'
        : '.relateditems a[data-image]:not(.is-hidden)';
      var swatches = card.querySelectorAll(selector);
      for (var i = 0; i < swatches.length; i++) {
        var src = swatches[i].getAttribute('data-image');
        if (src) preloadImage(src);
      }
    }

    /* Intent-based preloading: preloads swatch images the moment user interacts with a card */
    document.addEventListener('mouseover', function (e) {
      if (!e.target.closest) return;
      var card = e.target.closest('.product-grid-item');
      if (card && !card.dataset.swatchesPreloaded) {
        card.dataset.swatchesPreloaded = 'true';
        preloadCardSwatches(card, false);
      }
      var swatchLink = e.target.closest('.relateditems a[data-image]');
      if (swatchLink) {
        preloadImage(swatchLink.getAttribute('data-image'));
      }
      var moreBtn = e.target.closest('.relateditems__more, [data-toggle-swatches]');
      if (moreBtn) {
        var parentCard = moreBtn.closest('.product-grid-item');
        if (parentCard) {
          preloadCardSwatches(parentCard, true);
        }
      }
    }, { passive: true });

    document.addEventListener('touchstart', function (e) {
      if (!e.target.closest) return;
      var card = e.target.closest('.product-grid-item');
      if (card && !card.dataset.swatchesPreloaded) {
        card.dataset.swatchesPreloaded = 'true';
        preloadCardSwatches(card, false);
      }
    }, { passive: true });

    document.addEventListener('click', function (e) {
      var moreBtn = e.target.closest('.relateditems__more, [data-toggle-swatches]');
      if (moreBtn) {
        e.preventDefault();
        e.stopPropagation();
        var swatchesWrap = moreBtn.closest('.relateditems');
        if (swatchesWrap) {
          swatchesWrap.classList.add('is-visible');
          var card = moreBtn.closest('.product-grid-item');
          if (card) {
            preloadCardSwatches(card, true);
          }
        }
        return;
      }

      var a = e.target.closest('.product-grid-item .relateditems a');
      if (!a) return;
      e.preventDefault();

      var link = a.getAttribute('href');
      var image = a.getAttribute('data-image');
      var title = a.getAttribute('data-title');
      var card = a.closest('.product-grid-item');
      if (!card) return;

      var container = card.querySelector('.product-grid-item__image');
      if (container) {
        var containerLinks = container.querySelectorAll('a.product__media__holder, a.btn--quick.rounded');
        containerLinks.forEach(function (el) {
          el.setAttribute('href', link);
        });
        var containerImage = container.querySelector('.product__media img');
        if (containerImage && image) {
          preloadImage(image);
          containerImage.setAttribute('srcset', image);
          containerImage.setAttribute('src', image);
        }
      }

      var titleLink = card.querySelector('.product-grid-item__info-content a.product-grid-item__title');
      if (titleLink) {
        if (link) titleLink.setAttribute('href', link);
        if (title) titleLink.textContent = title;
      }
    });

    function isFeaturedCollection(el) {
      return !!el.closest(
        '.featured-collection, [data-section-type="featured-collection"], ' +
        '.featured-collections, [data-section-type="featured-collections"], ' +
        '.tab-collections, [data-section-type="tab-collections"], ' +
        '[id*="FeaturedCollection"], [id*="featured-collection"], [id*="featured_collection"], ' +
        '[id*="section_collection"]'
      );
    }

    function siblingPreviewFor(link) {
      if (isFeaturedCollection(link)) return null;

      var card = link.closest('[data-product-block]');
      if (!card) return null;
      var host = card.querySelector('[data-product-media-featured]') || card.querySelector('.product__media__image');
      if (!host) return null;

      var img = host.querySelector('.sibling-hover-preview');
      if (!img) {
        img = document.createElement('img');
        img.className = 'sibling-hover-preview';
        img.alt = '';
        img.setAttribute('aria-hidden', 'true');
        host.appendChild(img);
      }
      return img;
    }

    document.addEventListener('mouseover', function (e) {
      if (!e.target.closest) return;
      var link = e.target.closest('.relateditems a[data-image]');
      if (!link || isFeaturedCollection(link)) return;
      var src = link.getAttribute('data-image');
      var img = siblingPreviewFor(link);
      if (!img || !src) return;

      if (img.getAttribute('src') === src) {
        img.classList.add('is-visible');
        return;
      }
      img.classList.remove('is-visible');
      img.onload = function () {
        img.classList.add('is-visible');
      };
      img.src = src;
      if (img.complete && img.naturalWidth > 0) {
        img.classList.add('is-visible');
      }
    });

    document.addEventListener('mouseout', function (e) {
      if (!e.target.closest) return;
      var link = e.target.closest('.relateditems a[data-image]');
      if (!link || isFeaturedCollection(link)) return;
      if (e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('.relateditems a[data-image]') === link) {
        return;
      }
      var card = link.closest('[data-product-block]');
      var img = card && card.querySelector('.sibling-hover-preview');
      if (img) img.classList.remove('is-visible');
    });
  }

  /* =========================================================================
   * Collection Filter Checkbox & Tile Toggle Synchronization
   * ========================================================================= */
  function initCollectionFilterToggles() {
    function normalizeStr(str) {
      if (!str) return '';
      var s = str.toString().toLowerCase().trim();
      if (s.normalize) {
        s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      }
      return s.replace(/[^a-z0-9]/g, ' ').replace(/\s+/g, ' ').trim();
    }

    function getStyleKey(str) {
      if (!str) return '';
      var norm = normalizeStr(str);
      var words = norm.split(' ').filter(Boolean);
      return words[0] || '';
    }

    function findMatchingFilterInput(form, paramName, paramValue) {
      if (!form || !paramValue) return null;

      var escapeFn = window.CSS && window.CSS.escape ? window.CSS.escape : function (v) {
        return v.replace(/["\\]/g, '\\$&');
      };

      // 1. Direct match with paramName + paramValue
      if (paramName) {
        try {
          var direct = form.querySelector(
            'input[name="' + escapeFn(paramName) + '"][value="' + escapeFn(paramValue) + '"]'
          );
          if (direct) return direct;
        } catch (e) { }
      }

      // 2. Direct match with value only
      try {
        var directVal = form.querySelector('input[value="' + escapeFn(paramValue) + '"]');
        if (directVal) return directVal;
      } catch (e) { }

      var targetKey = getStyleKey(paramValue);
      var targetNorm = normalizeStr(paramValue);
      var allInputs = form.querySelectorAll('input[type="checkbox"]');

      // 3. Search through checkboxes by normalized value, label text, or style key
      for (var i = 0; i < allInputs.length; i++) {
        var input = allInputs[i];
        var inVal = input.value || input.getAttribute('value') || '';
        var inNorm = normalizeStr(inVal);

        if (inNorm && inNorm === targetNorm) {
          return input;
        }

        // Check associated label
        var label = null;
        if (input.id) {
          label = form.querySelector('label[for="' + escapeFn(input.id) + '"]');
        }
        if (!label) {
          label = input.closest('label') || (input.parentElement ? input.parentElement.querySelector('label') : null);
        }
        var labelText = label ? label.textContent : '';
        var labelNorm = normalizeStr(labelText);

        if (labelNorm && labelNorm === targetNorm) {
          return input;
        }

        // Match by style key (e.g., "quinn", "ace", "lulu", "anastasia", "lydia", "elodia", etc.)
        if (targetKey && targetKey.length >= 2) {
          var inKey = getStyleKey(inVal);
          var labelKey = getStyleKey(labelText);
          if (inKey === targetKey || labelKey === targetKey) {
            return input;
          }
          if ((inNorm && inNorm.indexOf(targetKey) === 0) || (labelNorm && labelNorm.indexOf(targetKey) === 0)) {
            return input;
          }
        }
      }

      return null;
    }

    function syncFilterCheckmarks() {
      var form = document.querySelector('[data-collection-filters-form]');
      var triggers = document.querySelectorAll('[data-filter-toggle]');

      triggers.forEach(function (trigger) {
        var item = trigger.closest('.list-collections__item');
        if (!item) return;

        var isActive = false;
        var paramName = trigger.getAttribute('data-filter-param');
        var paramValue = trigger.getAttribute('data-filter-value');

        if (form && paramValue) {
          var input = findMatchingFilterInput(form, paramName, paramValue);
          isActive = !!(input && input.checked);
        }

        // Fallback: check URL query parameters if form is not yet ready or input checked state not yet reflected
        if (!isActive && paramValue) {
          try {
            var urlParams = new URLSearchParams(window.location.search);
            var targetKey = getStyleKey(paramValue);
            urlParams.forEach(function (val, key) {
              if (paramName && key === paramName) {
                if (val === paramValue || normalizeStr(val) === normalizeStr(paramValue) || (targetKey && getStyleKey(val) === targetKey)) {
                  isActive = true;
                }
              } else if (key.indexOf('style') !== -1 || key.indexOf('custom') !== -1) {
                if (val === paramValue || (targetKey && getStyleKey(val) === targetKey)) {
                  isActive = true;
                }
              }
            });
          } catch (e) { }
        }

        item.classList.toggle('list-collections__item--filter-selected', isActive);
      });
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-filter-toggle]');
      if (!trigger) return;

      var form = document.querySelector('[data-collection-filters-form]');
      if (!form) return;

      var paramName = trigger.getAttribute('data-filter-param');
      var paramValue = trigger.getAttribute('data-filter-value');
      if (!paramValue) return;

      var input = findMatchingFilterInput(form, paramName, paramValue);
      if (!input) return;

      event.preventDefault();
      input.checked = !input.checked;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      syncFilterCheckmarks();
    });

    document.addEventListener('theme:filters:init', syncFilterCheckmarks);
    document.addEventListener('DOMContentLoaded', syncFilterCheckmarks);
    window.addEventListener('load', syncFilterCheckmarks);
    window.addEventListener('popstate', function () {
      setTimeout(syncFilterCheckmarks, 100);
    });
    if (document.readyState !== 'loading') {
      syncFilterCheckmarks();
    }
  }

  /* =========================================================================
   * Fix 1: Replace Expensive Scroll-Based Last-Slide Detection
   *
   * Palo Alto's theme.js attaches a raw `scroll` listener to every
   * carousel/grid slider inside featured-collection sections via
   * `handleLastSlideOverlayOnMobile`. That listener calls
   * `getBoundingClientRect()` on every pixel scrolled, causing severe
   * layout thrashing on mobile. The `is-last-slide-visible` class it
   * toggles has NO CSS rules for featured-collection, so the work is
   * pure waste.
   *
   * Strategy: On mobile, clone each slider node (which strips all event
   * listeners including the expensive scroll one) and re-insert it.
   * Then attach a lightweight IntersectionObserver on the last slide
   * to toggle the class without layout thrashing.
   * ========================================================================= */
  function optimizeCarouselScroll() {
    var isMobile = window.innerWidth < 768;
    if (!isMobile) return;

    var sections = document.querySelectorAll('[data-section-type="featured-collection"]');
    sections.forEach(function (section) {
      var sliders = section.querySelectorAll('[data-slider], .carousel--mobile, .grid--mobile');
      sliders.forEach(function (slider) {
        // Clone the slider to strip all event listeners (scroll, etc.)
        var clone = slider.cloneNode(true);
        var parent = slider.parentNode;
        parent.replaceChild(clone, slider);

        // Set up IntersectionObserver on the last child for the overlay toggle
        var lastChild = clone.lastElementChild;
        if (lastChild && 'IntersectionObserver' in window) {
          var observer = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                clone.parentNode.classList.toggle('is-last-slide-visible', entry.isIntersecting);
              });
            },
            { root: clone, threshold: 0.3 }
          );
          observer.observe(lastChild);
        }
      });
    });
  }

  /* =========================================================================
   * Fix 2: Optimize Swatch Image Decoding
   *
   * Each product card renders many swatch <img> tags from
   * swatches-product-grid.liquid. By default, browsers decode images
   * synchronously on the main thread, blocking interactivity.
   * Adding decoding="async" lets the browser decode off the main thread.
   * ========================================================================= */
  function optimizeSwatchImages() {
    var swatchImgs = document.querySelectorAll('.relateditems img');
    for (var i = 0; i < swatchImgs.length; i++) {
      swatchImgs[i].setAttribute('decoding', 'async');
    }
  }

  // Initialize features
  initSiblingSwatches();
  initCollectionFilterToggles();

  // Performance optimizations — run after DOM is interactive
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      optimizeCarouselScroll();
      optimizeSwatchImages();
    });
  } else {
    optimizeCarouselScroll();
    optimizeSwatchImages();
  }
})();
